import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import OfflineSurvey from './views/OfflineSurvey.vue';
import UnknowPage from './views/UnknowPage.vue';
import SurveyDone from './views/SurveyDone.vue';
import callPage from './views/CallPage.vue';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '*',
			component: UnknowPage
		},
		{
			path: '/',
			name: 'Default',
			redirect: '/inicio'
		},
		{
			path: '/pesquisa-de-satisfacao/offline',
			name: 'pesquisaOffline',
			component: OfflineSurvey
		},
		{
			path: '/pesquisa-de-satisfacao/pesquisa-finalizada',
			name: 'SurveyDone',
			component: SurveyDone
		},
		{
			path: '/pesquisa-publica',
			name: 'pesquisa',
			component: Home,
			meta: {
				token: false,
				slug: false,
				publicSurvey: true
			}
		},
		{
			path: '/inicio',
			name: 'callPage',
			component: callPage,
			meta: {
				token: false,
				slug: false,
				publicSurvey: true
			}
		},
		{
			path: '/:token',
			name: 'home',
			component: Home,
			meta: {
				token: true
			}
		},
		{
			path: '/pesquisa-publica/:slug',
			name: 'publicSurvey',
			component: Home,
			meta: {
				token: false,
				slug: true,
				publicSurvey: true
			}
		}
	]
});

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.token)) {
		if (!to.params.token) {
			next('/pesquisa-de-satisfacao/offline');
		} else {
			next();
		}
	} else {
		next();
	}
});

export default router;
